(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const filterSelect = document.getElementById('challengeFilter');
  const cards = Array.from(document.querySelectorAll('.challenge-card'));
  const toggleWrap = document.querySelector('.hc-toggle-wrap');
  const toggleBtn = document.getElementById('toggleCardsBtn');
  const container = document.querySelector('.healing-challenges-container');
  const noResultsMessage = document.getElementById('no-results-message');

  if (!container) return;

  const MAX_DESKTOP = parseInt(container.getAttribute('data-max-desktop') || '6', 10);
  const MAX_MOBILE  = parseInt(container.getAttribute('data-max-mobile')  || '3', 10);

  // Match CSS breakpoint
  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
  const getMaxVisible = () => (isMobile() ? MAX_MOBILE : MAX_DESKTOP);

  function applyInitialSlice() {
    const maxVisible = getMaxVisible();

    // Work only on currently visible (filtered) cards
    const visibleCards = cards.filter(card => card.style.display !== 'none');

    // Reset
    visibleCards.forEach(c => {
      c.classList.remove('extra-card');
      c.style.display = '';
    });

    // Hide beyond threshold
    visibleCards.forEach((c, idx) => {
      if (idx >= maxVisible) {
        c.classList.add('extra-card');
        c.style.display = 'none';
      }
    });

    // Toggle visibility
    if (toggleWrap) {
      if (visibleCards.length > maxVisible) {
        toggleWrap.style.display = 'block';
        if (toggleBtn) toggleBtn.textContent = toggleBtn?.dataset?.viewAll || 'View All';
      } else {
        toggleWrap.style.display = 'none';
      }
    }
  }

  function applyFilter() {
    const selectedFilter = filterSelect ? filterSelect.value : 'all';
    let visibleCount = 0;

    cards.forEach(card => {
      const cardVal = card.getAttribute('data-filter-value');
      if (selectedFilter === 'all' || cardVal === selectedFilter) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    // No-results message
    if (noResultsMessage) {
      noResultsMessage.style.display = (visibleCount === 0 && selectedFilter !== 'all') ? 'block' : 'none';
    }

    // Re-slice after filtering
    applyInitialSlice();
  }

  // Toggle handler
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      const extraCards = Array.from(document.querySelectorAll('.challenge-card.extra-card'));
      const currentlyHidden = extraCards.length ? (extraCards[0].style.display === 'none') : false;

      extraCards.forEach(card => {
        card.style.display = currentlyHidden ? '' : 'none';
      });

      toggleBtn.textContent = currentlyHidden
        ? (toggleBtn?.dataset?.viewLess || 'View Less')
        : (toggleBtn?.dataset?.viewAll  || 'View All');
    });
  }

  // Filter change
  if (filterSelect) {
    filterSelect.addEventListener('change', applyFilter);
  }

  // Initial render
  applyFilter();


});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
